export default "__VITE_ASSET__dd17d9be__"